module.exports = __webpack_public_path__ + "static/media/deleteIcon.28ff0452.svg";